import ExploreFirstPageConfig from "@/views/explore/ExploreFirstPageConfig.vue";
import ExploreMenuConfig from "@/views/explore/ExploreMenuConfig.vue";


const routes = [
 {
    path: '/Explore/FirstPageConfig',
    name: 'ExploreFirstPageConfig',
    component: ExploreFirstPageConfig,
    meta:{requiredAuth:true}
  },
 {
    path: '/Explore/configMenu',
    name: 'ExploreMenuConfig',
    component: ExploreMenuConfig,
    meta:{requiredAuth:true}
  },

]

export default routes